"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./styles/_content-placeholder.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ContentPlaceholder = function ContentPlaceholder(_ref) {
  var className = _ref.className;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('content-placeholder', className)
  }, _react.default.createElement(_reactContentLoader.default, {
    height: 205,
    width: 205,
    speed: 1.5,
    primaryColor: "rgb(232, 236, 240, 0.75)",
    secondaryColor: "rgb(232, 236, 240, 0.2)"
  }, _react.default.createElement("rect", {
    x: "20",
    y: "20",
    rx: "0",
    ry: "0",
    width: "90",
    height: "90"
  }), _react.default.createElement("rect", {
    x: "120",
    y: "23",
    rx: "4",
    ry: "4",
    width: "63",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "120",
    y: "43",
    rx: "4",
    ry: "4",
    width: "45",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "120",
    y: "63",
    rx: "3",
    ry: "3",
    width: "50",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "120",
    y: "83",
    rx: "4",
    ry: "4",
    width: "63",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "20",
    y: "133",
    rx: "3",
    ry: "3",
    width: "150",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "20",
    y: "153",
    rx: "3",
    ry: "3",
    width: "91",
    height: "10"
  }), _react.default.createElement("rect", {
    x: "20",
    y: "173",
    rx: "3",
    ry: "3",
    width: "162",
    height: "10"
  })));
};

var _default = (0, _react.memo)(ContentPlaceholder);

exports.default = _default;